module.exports = __webpack_public_path__ + "img/qianjiangjidi.9988f2ec.png";